import React from "react"
import { ContactService } from "../services/contactService.js"

function FieldRow({ label, children }) {
    return (
        <div className="d-flex align-items-baseline gap-2">
            <span
                className="text-secondary small fw-medium flex-shrink-0"
                style={{ width: "5.25rem" }}
            >
                {label}
            </span>
            <span className="text-dark">
                {children}
            </span>
        </div>
    )
}

function AddressBlock({ address }) {
    return (
        <>
            {address.street}
            <br />
            {address.city}, {address.province}, {address.country} {address.postalCode}
        </>
    )
}

/** @param {{ order: any, primaryContact?: { name?: string; company?: string; phone?: string; email?: string; hasAny?: boolean }, shipping: any, billing: any }} props */
export default function ShippingBillingInfo({ order, primaryContact, shipping, billing }) {
    const contact = primaryContact ?? {}
    const showCompany = Boolean(String(contact.company ?? "").trim())
    const hasAny = Boolean(contact.hasAny)

    const normalizeEmail = (value) => String(value ?? "").trim().toLowerCase()
    const normalizePhone = (value) => ContactService.formatPhone(String(value ?? "").trim()).replace(/\D/g, "")

    const primaryEmail = normalizeEmail(order?.email)
    const primaryPhone = normalizePhone(order?.phone)
    const shipToEmail = String(order?.ship_to?.email ?? "").trim()
    const billToEmail = String(order?.bill_to?.email ?? "").trim()
    const shipToEmailNorm = normalizeEmail(shipToEmail)
    const billToEmailNorm = normalizeEmail(billToEmail)
    const shipToPhoneNorm = normalizePhone(order?.ship_to?.phone)
    const billToPhoneNorm = normalizePhone(order?.bill_to?.phone)
    const shipToPhone = ContactService.formatPhone(String(order?.ship_to?.phone ?? "").trim())
    const billToPhone = ContactService.formatPhone(String(order?.bill_to?.phone ?? "").trim())
    const showShipPhone = Boolean(shipToPhoneNorm) && shipToPhoneNorm !== primaryPhone
    const showShipEmail = Boolean(shipToEmailNorm) && shipToEmailNorm !== primaryEmail
    const showBillPhone = Boolean(billToPhoneNorm) && billToPhoneNorm !== primaryPhone
    const showBillEmail = Boolean(billToEmailNorm) && billToEmailNorm !== primaryEmail
    return (
        <div className="card rounded shadow-sm h-100" style={{ backgroundColor: "#ffebee" }}>
            <div className="card-body p-4">
                <h2 className="fs-5 fw-semibold text-dark mb-3">Primary Contact</h2>
                {!hasAny ? (
                    <p className="fst-italic text-secondary mb-0">(Not provided)</p>
                ) : (
                    <div className="d-flex flex-column gap-2">
                        {contact.name ? <FieldRow label="Name">{contact.name}</FieldRow> : null}
                        {showCompany ? <FieldRow label="Company">{contact.company}</FieldRow> : null}
                        {contact.phone ? <FieldRow label="Phone">{contact.phone}</FieldRow> : null}
                        {contact.email ? <FieldRow label="Email">{contact.email}</FieldRow> : null}
                    </div>
                )}
            </div>

            <div className="border-top p-4">
                <h2 className="fs-5 fw-semibold text-dark mb-3">Shipping Information</h2>
                <div className="d-flex flex-column gap-2">
                    {shipping.isPickup ? (
                        <>
                            <FieldRow label="Pick up in store">{shipping.pickupStore}</FieldRow>
                            <FieldRow label="Location">{shipping.location}</FieldRow>
                        </>
                    ) : (
                        <>
                            <FieldRow label="Name">{shipping.name}</FieldRow>
                            <FieldRow label="Address">
                                <AddressBlock address={shipping.address} />
                            </FieldRow>
                            {showShipPhone ? (
                                <FieldRow label="Phone">{shipToPhone}</FieldRow>
                            ) : null}
                            {showShipEmail ? (
                                <FieldRow label="Email">{shipToEmail}</FieldRow>
                            ) : null}
                        </>
                    )}
                </div>
            </div>

            <div className="border-top p-4">
                <h2 className="fs-5 fw-semibold text-dark mb-3">Billing Information</h2>
                <div className="d-flex flex-column gap-2">
                    <FieldRow label="Name">{billing.name}</FieldRow>
                    <FieldRow label="Address">
                        <AddressBlock address={billing.address} />
                    </FieldRow>
                    {showBillPhone ? (
                        <FieldRow label="Phone">{billToPhone}</FieldRow>
                    ) : null}
                    {showBillEmail ? (
                        <FieldRow label="Email">{billToEmail}</FieldRow>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
